import React from 'react';
import { handleActions } from 'redux-actions';
import { get as getPath, set as setPath, toPath, merge } from 'lodash';
import * as ActionTypes from '../../../constants/ActionTypes';

// TODO: needs be redone i think (legacy structure)
const pageTitleDataReducerDefault = {
    pageTitle: '',
    favicon: ''
};

const pageTitleDataReducer = handleActions(
    {
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            let pathCheck = action.path.split('.');
            if (pathCheck[0] === 'page') {
                pathCheck.shift();
                return merge({}, state, setPath({}, pathCheck, action.value));
            } else {
                return state;
            }
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('page')) {
                return { ...state, ...action.theme.page };
            }
            return state;
        }
    },
    pageTitleDataReducerDefault
);

export default pageTitleDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/pageTitle.js